// #region imports

// --- HS Code
import { PinnedJournalEntryTextModel } from './pinned-journal-entry-text-model';

// #endregion

export interface PinnedJournalEntryGroupModel {
  leader: PinnedJournalEntryTextModel[];
  teamMember: PinnedJournalEntryTextModel[];
}
